import Raven from 'raven-js';
import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { Image } from 'foundations-components/transitional/components/Image';
import { FontOption } from './FontOption';
import { jsx as _jsx } from "react/jsx-runtime";
class CustomFontOption extends Component {
  constructor(props) {
    super(props);
    this.onSvgError = this.onSvgError.bind(this);
    this.state = {
      useFallback: false
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  onSvgError() {
    const {
      font,
      variant
    } = this.props;
    const {
      family
    } = font || {};
    Raven.captureMessage('Missing valid Custom font SVG', {
      extra: {
        family,
        variant
      }
    });
    this.setState({
      useFallback: true
    });
  }
  renderFallback() {
    const {
      font,
      variant
    } = this.props;
    const {
      family,
      styles = {}
    } = font || {};
    if (variant) {
      return /*#__PURE__*/_jsx(FontOption, {
        fontFamily: family,
        cssStyles: styles[variant],
        children: variant
      });
    }
    return /*#__PURE__*/_jsx(FontOption, {
      fontFamily: family,
      children: family
    });
  }
  render() {
    const {
      font,
      variant
    } = this.props;
    const {
      defaultSvgUrl,
      svgUrls = {}
    } = font;
    const svgUrl = variant ? svgUrls[variant] : defaultSvgUrl;
    if (this.state.useFallback || !svgUrl) {
      return this.renderFallback();
    }
    return /*#__PURE__*/_jsx(Image, {
      onError: this.onSvgError,
      src: svgUrl
    });
  }
}
export default CustomFontOption;